"use client";

import React from "react";
import type { ListBlockWrapperProps } from "rivals/components/pages/Article/Blocks/ListBlock/types";
import useFetchListData from "rivals/services/fetchListData/useFetchListData";
import ListBlock from ".";

export default function ListBlockContainer(
  props: ListBlockWrapperProps
): React.JSX.Element {
  const { data } = useFetchListData({ id: props.listId });
  return <ListBlock list={data?.list} />;
}
